import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { iif } from 'rxjs';
import { CommonServices } from 'src/app/Common/CommonServices';
import { PlatformChargesClient, RoomOwnerAccountDetail, User, WebinarClient, WebinarRoom } from 'src/app/Services/WOWApi.Service';

@Component({
    selector: 'app-edit-host-account-detail',
    templateUrl: './edit-host-account-detail.component.html',
    styleUrls: ['./edit-host-account-detail.component.css'],
    standalone: false
})
export class EditHostAccountDetailComponent implements OnInit {
  accountDetail!: UntypedFormGroup;
  isSubmitting =false;
  userRoom: WebinarRoom;
  userDetails: User;
  constructor(
    private fb: UntypedFormBuilder,
    private dialogRef: MatDialogRef<EditHostAccountDetailComponent>,
    private webinarClient: WebinarClient,
    private commonServices: CommonServices,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private platformChargesCLient: PlatformChargesClient
  ) {
    this.userDetails = JSON.parse(localStorage.getItem("UserInfo"));
  }

  ngOnInit(): void {
    this.buildForm();
    if (this.data !== undefined && this.data !== null) {
      if (this.data.isNewAccount === false) {
        this.patchAccountData(this.data.account)
      }
      if (this.data.isNewAccount === true) {
        this.getUserRoom();
      }
    }
  }

  buildForm() {
    this.accountDetail = this.fb.group({
      accountId: [0, [Validators.required]],
      accountNumber: ['', [Validators.required, Validators.minLength(8)]],
      nameOnAccount: ['', [Validators.required]],
      routingNumber: ['', [Validators.required]],
      streetAddress: ['', [Validators.required]],
      city: ['', [Validators.required]],
      state: ['', [Validators.required]],
      zipCode: ['', [Validators.required, Validators.maxLength(5)]],
      webinarRoomOwnerId: ['', [Validators.required]],
      isUpdateAllowed: [true, [Validators.required]],
      isActive: [true, [Validators.required]]
    })
  }

  patchAccountData(account: RoomOwnerAccountDetail) {
    this.accountDetail.controls.accountId.patchValue(account.accountId);
    this.accountDetail.controls.accountNumber.patchValue(account.accountNumber);
    this.accountDetail.controls.nameOnAccount.patchValue(account.nameOnAccount);
    this.accountDetail.controls.routingNumber.patchValue(account.routingNumber);
    this.accountDetail.controls.streetAddress.patchValue(account.streetAddress);
    this.accountDetail.controls.city.patchValue(account.city);
    this.accountDetail.controls.state.patchValue(account.state);
    this.accountDetail.controls.zipCode.patchValue(account.zipCode);
    this.accountDetail.controls.webinarRoomOwnerId.patchValue(account.webinarRoomOwnerId);
    this.accountDetail.controls.isUpdateAllowed.patchValue(account.isUpdateAllowed);
    this.accountDetail.controls.isActive.patchValue(account.isActive);
  }

  getUserRoom() {
    this.webinarClient.getWebinarRooms(false).subscribe(res => {
      const rooms = res.filter(x => x.webinarRoomOwners.find(y => y.userId === this.userDetails.id));
      this.userRoom = rooms[0];
      this.accountDetail.controls.webinarRoomOwnerId.patchValue(this.userRoom.webinarRoomOwners[0].webinarOwnerId);
    }, error => {
      this.commonServices.showMessage('error', error, 5);
    });
  }

  onUpdateAccountDetail() {
    this.accountDetail.markAllAsTouched();
    this.isSubmitting = true;
    if (!this.accountDetail.valid) {
      this.commonServices.showMessage('error', 'Please fill all the required fields', 5);
      this.isSubmitting = false;
      return;
    }
    const addApi = this.platformChargesCLient.addRoomOwnerAccountDetail(this.userDetails.id , this.accountDetail.value);
    const updateApi = this.platformChargesCLient.updateRoomOwnerAccountDetail(this.userDetails.id , this.accountDetail.value);
    iif(() => this.data.isNewAccount === true, addApi, updateApi).subscribe(res => {
      if (res === true) {
        if (this.data.isNewAccount === false) {
          this.dialogRef.close({action: 'update', obj: this.accountDetail.value});
        } else {
          this.dialogRef.close({action: 'refresh'});
        }
      } else {
        this.commonServices.showMessage('error', 'Could not add new account details', 5);
        this.onCancel();
      }
      this.isSubmitting = false;
    });
  }

  onCancel() {
    this.dialogRef.close(null);
  }

  onlyNumbersAllowed(event: KeyboardEvent) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      this.commonServices.showMessage('error', 'Only numbers allowed.', 2);
    }
  }

  handlePaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData || window['clipboardData'];
    const pastedText = Number(clipboardData.getData('text'));
    if (Number.isNaN(pastedText)) {
      event.preventDefault();
      this.commonServices.showMessage('error', 'Only numbers allowed.', 2);
    }
  }

}
